import React, { useState } from 'react';
import './App.css';
import Topbar from './components/Topbar';
import MapLayout from './components/MapLayout';
import Sidebar from './components/Sidebar';

function App() {
  const [mapRef, setMapRef] = useState(null);

  const handleAddWashroom = (washroomData) => {
    // Pass the data to the MapLayout component
    if (mapRef && mapRef.addNewWashroom) {
      mapRef.addNewWashroom(washroomData);
    }
  };

  return (
    <div className="App">
      <Topbar onAddWashroom={handleAddWashroom} />
      <div className="main-content">
        <MapLayout ref={setMapRef} />
        {/* <Sidebar /> */}
      </div>
    </div>
  );
}

export default App;
